import {
  createContext,
  useMemo,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction, ReactElement,
} from 'react';
import PropTypes from 'prop-types';

export interface LookupsContextType {
  lookupsData: null | any;
  setLookupsData: Dispatch<SetStateAction<any>>
}

export const LookupsContext = createContext<LookupsContextType>({
  lookupsData: null,
  setLookupsData: () => {},
});

interface LookupsProviderProps {
  children: ReactNode;
}

const LookupsProvider = ({ children }: LookupsProviderProps): ReactElement => {
  const [lookupsData, setLookupsData] = useState();

  const contextValue = useMemo((
    () => ({
      lookupsData,
      setLookupsData,
    }
    )), [lookupsData]);

  return (
    <LookupsContext.Provider value={contextValue}>
      {children}
    </LookupsContext.Provider>
  );
};

LookupsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LookupsProvider;
